import React from "react";
import { Typography, Box } from "@mui/material";
import { styled, keyframes } from "@mui/system";
import avatar from "../../assets/images/greetings.png";

// Animaciones
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const waveAnimation = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(15deg); }
  50% { transform: rotate(0deg); }
  75% { transform: rotate(-15deg); }
  100% { transform: rotate(0deg); }
`;

// Contenedor principal estilizado
const HomeContainer = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.default,
  position: "relative",
  animation: `${fadeIn} 1s ease-in-out`,
  padding: theme.spacing(3),
}));

// Texto destacado estilizado
const HighlightedText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightBold,
  display: "inline-block",
  animation: `${fadeIn} 1.5s ease-in-out`,
}));

// Texto introductorio estilizado
const IntroText = styled(Typography)(({ theme }) => ({
  maxWidth: "600px",
  margin: `${theme.spacing(2)} auto`,
  fontSize: theme.typography.body1.fontSize,
  color: theme.palette.text.primary,
  animation: `${fadeIn} 2s ease-in-out`,
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.body2.fontSize,
  },
}));

// Contenedor del avatar estilizado
const AvatarContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(5),
  right: "50%",
  transform: "translate(50%, 10px)",
  textAlign: "center",
}));

// Imagen del avatar estilizada
const AvatarImage = styled("img")(({ theme }) => ({
  width: "140px",
  height: "auto",
  borderRadius: "50%",
  backgroundColor: theme.palette.background.default,
  animation: `${waveAnimation} 2s infinite`,
  cursor: "pointer",
}));

// Tooltip estilizado
const TooltipText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightBold,
  marginTop: theme.spacing(1),
  opacity: 0,
  transition: "opacity 0.3s ease",
  position: "absolute",
  top: "-30px",
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1),
  borderRadius: theme.shape.borderRadius,
  zIndex: 10,
}));

const TooltipContainer = styled(Box)(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  "&:hover": {
    "& > p": {
      opacity: 1,
    },
  },
}));

const HomeComponent = () => {
  return (
    <HomeContainer>
      <Typography variant="h3" component="h1" gutterBottom>
        Bienvenido, soy{" "}
        <HighlightedText component="span" variant="h3">
          Guadalupe Rosas
        </HighlightedText>
      </Typography>
      <IntroText variant="body1">
        Soy un desarrollador Fullstack Junior apasionado por crear soluciones
        innovadoras en el desarrollo web y backend. Manejo tecnologías modernas
        como React, Spring Boot y AWS, lo que me permite diseñar y construir
        aplicaciones escalables y de alto rendimiento. Mi enfoque está en
        aprender continuamente, colaborar eficazmente en equipos
        multidisciplinarios y aportar valor tangible a los proyectos a través de
        mis habilidades técnicas y una mentalidad orientada a la mejora
        constante.
      </IntroText>
      <AvatarContainer>
        <TooltipContainer>
          <AvatarImage src={avatar} alt="Avatar" />
          <TooltipText>¡Saludos!</TooltipText>
        </TooltipContainer>
      </AvatarContainer>
    </HomeContainer>
  );
};

export default HomeComponent;